/** The player reloads its manifest when a scene's path changes, ignoring the query; compare them the same way. */
export function sameScenePath(a: string, b: string): boolean {
  return a.split('?')[0] === b.split('?')[0];
}

/**
 * Whether playback held at a scene still building can carry on into it now: the scene is built and the manifest can
 * load it, and, when its path is new, the player has already loaded the manifest that has it.
 */
export function canResume({ built, pathAtWait, pathNow, loadedSinceBuilt }: { built: boolean; pathAtWait: string; pathNow: string; loadedSinceBuilt: boolean }): boolean {
  if (!built || !pathNow) return false;
  return sameScenePath(pathAtWait, pathNow) || loadedSinceBuilt;
}
